import { PubSub } from "@/shared/utils/pubSub";
import { useSubscribe } from "@/shared/utils/useSubscribe";

type FieldType = "event" | "familyMember";
type Callback = (param: {
    /** Array path the new instance is appended to; its new row receives focus. */
    fieldName: string;
    /** Other array paths for the same row that must gain an instance at the same position. */
    coupledFieldNames?: string[];
    type: FieldType;
    newItemIndex: number;
    mappedAssertion: string;
}) => void;

const addFieldPubSub = new PubSub<Callback>();

export const publishAddField = addFieldPubSub.publish;
export const useOnAddField = (callback: Callback) => useSubscribe(addFieldPubSub, callback);
